import React from 'react';
import DigitalCard from './components/DigitalCard';
import styled from 'styled-components';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1a1f2c;
  padding: 0rem;
`;

function App() {
  return (
    <AppContainer>
      <DigitalCard />
    </AppContainer>
  );
}

export default App;
